import { render, staticRenderFns } from "./client.vue?vue&type=template&id=d25ff502"
import script from "./client.vue?vue&type=script&lang=ts"
export * from "./client.vue?vue&type=script&lang=ts"
import style0 from "./client.vue?vue&type=style&index=0&id=d25ff502&prod&lang=scss"
import style1 from "./client.vue?vue&type=style&index=1&id=d25ff502&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports